// Portfolio Images
//Java
import backtester from "../assets/images/projects/java/backtester.JPG";
import schoolmanagement from "../assets/images/projects/java/schoolmanagement.PNG";
import skibooking from "../assets/images/projects/java/skibooking.gif";
import stockinventory from "../assets/images/projects/java/stockinventory.gif";

//React
import _1inch1 from "../assets/images/projects/react/1inch1.gif";
import _1inch2 from "../assets/images/projects/react/1inch2.png";
import airbnb from "../assets/images/projects/react/airbnb.JPG";
import alanai1 from "../assets/images/projects/react/alanai1.JPG";
import alanai2 from "../assets/images/projects/react/alanai2.JPG";
import auditwizard01 from "../assets/images/projects/react/auditWizard01.png";
import auditwizard02 from "../assets/images/projects/react/auditWizard02.png";
import auditwizard1 from "../assets/images/projects/react/auditWizard1.png";
import auditwizard2 from "../assets/images/projects/react/auditWizard2.png";
import auditwizard3 from "../assets/images/projects/react/auditWizard3.png";
import auditwizard4 from "../assets/images/projects/react/auditWizard4.png";
import auditwizard5 from "../assets/images/projects/react/auditWizard5.png";
import beranames1 from "../assets/images/projects/react/beranames1.gif";
import blockexplorer1 from "../assets/images/projects/react/blockexplorer1.png";
import blockexplorer2 from "../assets/images/projects/react/blockexplorer2.png";
import boilerplate1 from "../assets/images/projects/react/boilerplate1.png";
import boilerplate2 from "../assets/images/projects/react/boilerplate2.png";
import boilerplate3 from "../assets/images/projects/react/boilerplate3.png";
import boilerplate4 from "../assets/images/projects/react/boilerplate4.png";
import boilerplate5 from "../assets/images/projects/react/boilerplate5.png";
import calculators1 from "../assets/images/projects/react/calculators1.JPG";
import calculators2 from "../assets/images/projects/react/calculators2.JPG";
import corona from "../assets/images/projects/react/corona.JPG";
import crowdfunding1 from "../assets/images/projects/react/crowdfunding1.png";
import crowdfunding2 from "../assets/images/projects/react/crowdfunding2.png";
import crowdfunding3 from "../assets/images/projects/react/crowdfunding3.png";
import forexlens1 from "../assets/images/projects/react/forexlens1.png";
import google1 from "../assets/images/projects/react/google1.gif";
import google2 from "../assets/images/projects/react/google2.JPG";
import google3 from "../assets/images/projects/react/google3.JPG";
import hydra1 from "../assets/images/projects/react/hydra1.JPG";
import hydra2 from "../assets/images/projects/react/hydra2.JPG";
import makeracademy1 from "../assets/images/projects/react/makeracademy1.gif";
import makeracademy10 from "../assets/images/projects/react/makeracademy10.png";
import makeracademy11 from "../assets/images/projects/react/makeracademy11.png";
import makeracademy12 from "../assets/images/projects/react/makeracademy12.png";
import makeracademy13 from "../assets/images/projects/react/makeracademy13.png";
import makeracademy14 from "../assets/images/projects/react/makeracademy14.png";
import makeracademy15 from "../assets/images/projects/react/makeracademy15.png";
import makeracademy2 from "../assets/images/projects/react/makeracademy2.png";
import makeracademy3 from "../assets/images/projects/react/makeracademy3.png";
import makeracademy4 from "../assets/images/projects/react/makeracademy4.png";
import makeracademy5 from "../assets/images/projects/react/makeracademy5.png";
import makeracademy6 from "../assets/images/projects/react/makeracademy6.png";
import makeracademy7 from "../assets/images/projects/react/makeracademy7.png";
import makeracademy8 from "../assets/images/projects/react/makeracademy8.png";
import makeracademy9 from "../assets/images/projects/react/makeracademy9.png";
import nft1 from "../assets/images/projects/react/nft1.gif";
import nft2 from "../assets/images/projects/react/nft2.png";
import nft3 from "../assets/images/projects/react/nft3.png";
import nft4 from "../assets/images/projects/react/nft4.png";
import nft5 from "../assets/images/projects/react/nft5.png";
import nft6 from "../assets/images/projects/react/nft6.png";
import nft7 from "../assets/images/projects/react/nft7.png";
import nft8 from "../assets/images/projects/react/nft8.png";
import portfolio2_1 from "../assets/images/projects/react/portfolio2.gif";
import portfolio2_2 from "../assets/images/projects/react/portfolio2_2.png";
import productlanding from "../assets/images/projects/react/productlanding.gif";
import projectsmern1 from "../assets/images/projects/react/projectsmern1.jpg";
import projectsmern2 from "../assets/images/projects/react/projectsmern2.JPG";
import receipts1 from "../assets/images/projects/react/receipts1.png";
import receipts2 from "../assets/images/projects/react/receipts2.png";
import receipts3 from "../assets/images/projects/react/receipts3.png";
import resume1 from "../assets/images/projects/react/resume1.JPG";
import resume2 from "../assets/images/projects/react/resume2.JPG";
import resume3 from "../assets/images/projects/react/resume3.JPG";
import rightdrive1 from "../assets/images/projects/react/rightdrive1.png";
import tamuweb1 from "../assets/images/projects/react/tamu1.png";
import tamuweb2 from "../assets/images/projects/react/tamu2.png";
import tamuweb3 from "../assets/images/projects/react/tamu3.png";
import tamuweb4 from "../assets/images/projects/react/tamu4.png";
import shakepay from "../assets/images/projects/react/shakepay.gif";
import shakepay2 from "../assets/images/projects/react/shakepay2.png";
import slack1 from "../assets/images/projects/react/slack1.JPG";
import slack2 from "../assets/images/projects/react/slack2.JPG";
import thebig6ix1 from "../assets/images/projects/react/thebig6ix1.png";
import thebig6ix2 from "../assets/images/projects/react/thebig6ix2.png";
import thebig6ix3 from "../assets/images/projects/react/thebig6ix3.png";
import thebig6ix4 from "../assets/images/projects/react/thebig6ix4.png";
import tictactoe1 from "../assets/images/projects/react/tictactoe1.png";
import tictactoe2 from "../assets/images/projects/react/tictactoe2.png";
import windows11 from "../assets/images/projects/react/windows11.png";
import windows11_2 from "../assets/images/projects/react/windows11_2.png";
import windows11_3 from "../assets/images/projects/react/windows11_3.png";

//React Native
import auramoney from "../assets/images/projects/reactnative/aura-money.png";
import dabi1 from "../assets/images/projects/reactnative/dabi1.jpg";
import dabi2 from "../assets/images/projects/reactnative/dabi2.png";
import ofaadawa from "../assets/images/projects/reactnative/ofaa-dawa.jpg";
import tamu from "../assets/images/projects/reactnative/tamu-app.jpg";
import trayjourney from "../assets/images/projects/reactnative/trayjourney.jpg";
import whatsapp from "../assets/images/projects/reactnative/whatsapp.png";

// Videos
import auraWebappVideo from "../assets/videos/aura-webapp.mp4";

//Solidity
import fortunate from "../assets/images/projects/solidity/fortunate.gif";

//TradingView
import fractals from "../assets/images/projects/tradingview/fractals.JPG";
import fvg from "../assets/images/projects/tradingview/fvg.JPG";
import levels from "../assets/images/projects/tradingview/levels.JPG";
import marketstructure from "../assets/images/projects/tradingview/marketstructure.JPG";
import orderblocks from "../assets/images/projects/tradingview/orderblocks.JPG";
import range from "../assets/images/projects/tradingview/range.JPG";
import sessions from "../assets/images/projects/tradingview/sessions.JPG";
import smt from "../assets/images/projects/tradingview/smt.JPG";
import stophunt from "../assets/images/projects/tradingview/stophunt.JPG";
import supplydemand from "../assets/images/projects/tradingview/supplydemand.JPG";

//web
import pickleball1 from "../assets/images/projects/react/pickleball1.png";
import pickleball2 from "../assets/images/projects/react/pickleball2.png";
import pickleball3 from "../assets/images/projects/react/pickleball3.png";
import pickleball4 from "../assets/images/projects/react/pickleball4.png";
import journal1 from "../assets/images/projects/web/journal1.JPG";
import journal2 from "../assets/images/projects/web/journal2.JPG";
import journal3 from "../assets/images/projects/web/journal3.JPG";
import webresume from "../assets/images/projects/web/resume.gif";
import webresume1 from "../assets/images/projects/web/resume1.JPG";
import webresume2 from "../assets/images/projects/web/resume2.JPG";
import webresume3 from "../assets/images/projects/web/resume3.JPG";
import tra1 from "../assets/images/projects/web/tra1.JPG";
import tra2 from "../assets/images/projects/web/tra2.JPG";
import tra3 from "../assets/images/projects/web/tra3.JPG";

export const portfolioImages = {
  java: {
    backtester: [backtester],
    schoolmanagement: [schoolmanagement],
    skibooking: [skibooking],
    stockinventory: [stockinventory],
  },

  react: {
    airbnb: [airbnb],
    alanai: [alanai1, alanai2],
    positionsize: [calculators1, calculators2],
    corona: [corona],
    google: [google1, google2, google3],
    hydra: [hydra1, hydra2],
    beranames: [beranames1],
    resume: [resume1, resume2, resume3],
    slack: [slack1, slack2],
    blockexplorer: [blockexplorer1, blockexplorer2],
    projectsmern: [projectsmern1, projectsmern2],
    productlanding: [productlanding],
    tictactoe: [tictactoe1, tictactoe2],
    pickleball: [pickleball1, pickleball2, pickleball3, pickleball4],
    boilerplate: [
      boilerplate1,
      boilerplate2,
      boilerplate3,
      boilerplate4,
      boilerplate5,
    ],
    shakepay: [shakepay, shakepay2],
    portfolio: [portfolio2_1, portfolio2_2],
    windows11: [windows11, windows11_2, windows11_3],
    nft: [nft1, nft2, nft3, nft4, nft5, nft6, nft7, nft8],
    thebig6ix: [thebig6ix1, thebig6ix2, thebig6ix3, thebig6ix4],
    makeracademy: [
      makeracademy1,
      makeracademy2,
      makeracademy3,
      makeracademy4,
      makeracademy5,
      makeracademy6,
      makeracademy7,
      makeracademy8,
      makeracademy9,
      makeracademy10,
      makeracademy11,
      makeracademy12,
      makeracademy13,
      makeracademy14,
      makeracademy15,
    ],
    auditwizard: [
      auditwizard01,
      auditwizard02,
      auditwizard1,
      auditwizard2,
      auditwizard3,
      auditwizard4,
      auditwizard5,
    ],
    forexlens: [forexlens1, "https://www.youtube.com/embed/oGvcxbVTzTM"],
    rightdrive: [rightdrive1, "https://www.youtube.com/embed/Dt5FhbhgfCU"],
    _1inch: [_1inch1, _1inch2, "https://www.youtube.com/embed/fteCLhMdFVo"],
    crowdfunding: [crowdfunding1, crowdfunding2, crowdfunding3],
    receipts: [receipts1, receipts2, receipts3],
    aurawebapp: [auraWebappVideo],
    tamuweb: [tamuweb1, tamuweb2, tamuweb3, tamuweb4],
  },

  reactNative: {
    auramoney: [auramoney],
    dabi: [dabi1, dabi2],
    ofaadawa: [ofaadawa],
    tamu: [tamu],
    trayjourney: [trayjourney],
    whatsapp: [whatsapp],
  },

  solidity: { fortunate: [fortunate] },

  tradingview: {
    fractals: [fractals],
    fvg: [fvg],
    levels: [levels],
    marketstructure: [marketstructure],
    orderblocks: [orderblocks],
    sessions: [sessions],
    smt: [smt],
    stophunt: [stophunt],
    supplydemand: [supplydemand],
    range: [range],
  },

  web: {
    resume: [webresume, webresume1, webresume2, webresume3],
    journal: [journal1, journal2, journal3],
    tra: [tra1, tra2, tra3],
  },
};
